import NetworkApi from '../libs/network/d'
import dayjs, { Dayjs } from 'dayjs'
import _ from 'lodash'
export interface IHorse {
    name: string
    horseId: number
}
export interface IHorseVisit {
    video_url: string, horse_id: number | string, last_visit: Date | string | number, reminder_date: Date | string | number, notes: string, event_type: number | string, _ID?: string,
}

export interface Profile {
    paddock_name: string,
    yob: string,
    weight: string,
    height: string,
    gender: string,
    register_number: string,
    microchip_no: string,
    breed: string,
    colour: string,
    discipline: string,
    sire: string,
    dam: string,
    dam_sire: string,
    date_purchased: string,
    gear_used: string,
    notes: string,
    _ID?: string,
    horse_id?: string,
    avatar: string,
    parent_order_id?: number,
    show_name?: string,
    nzcar?: string,
    insurance_num: string | number
}

export interface Contact {
    name: string,
    email: string,
    phone: string,
    address: string,
    profile_id: string,
    _ID?: string,
    event_type: number | string
}

export interface Contact {
    name: string,
    email: string,
    phone: string,
    address: string,
    profile_id: string,
    _ID?: string,
    event_type: number | string
}

export interface Files {
    _ID?: string,
    name: string,
    url: string,
    profile_id?: string,
    uid?: string,
    status?: string,
    response?: any, // custom error message to show
    [key: string]: any,
    calendar_id?: string,
    visit_id?: string,
}

export interface ShareKey {
    _ID?: string,
    profile_id: string,
    sharing_key: string, // custom error message to show
    config: Array<string | number>
}

export interface Orders {
    parent_order_id: number,
    quantity: number,
    expiry_date: Date,
    order_status: string,
    available?: number,
}


export interface Preview {
    profile: Profile,
    records: {
        [key: number]: {
            visits: Array<IHorseVisit>,
            contacts: Array<Contact>,
        }
    }
}

export interface Calendar {
    _ID: string,
    date: string | number,
    end_date: string | number
    event_type: string,
    address: string,
    profile_id: string,
    description: string,
    notes: string,
    usr_name?: string,
    usr_email?: string,
    files?: Array<Object>,
    cct_created?: string,
    status?: string,
    public_type?: string
    regions?: string
}
export interface PageList<T> {
    data: T,
    page: number,
    total: number
}
export interface CalendarUpdate {
    notes?: string,
    address?: string,
    message: string,
    date: string,
    end_date: string,
    event_type: string,
    public_type?: string
    regions?: string,
    calendar_type?: string,
    link?: string,
    contact_email?: string,
}

class HorseNetwork {
    private network: NetworkApi

    constructor(network: NetworkApi) {
        this.network = network
    }

    private _setDate = (date: Date | string | number) => {
        return date == '0' ? date : dayjs(date).unix().toString()
    }

    private _getDate = (date: Date | string | number) => {
        return date == '0' ? 'Unavailable' : dayjs(Number(date) * 1000).toString()
    }
    public get = () => {
        console.log('get horses')
        const data = this.network.getItem<Array<IHorse>>('reset/v1/horses')
        return data
    }

    public add = (item: IHorseVisit) => {
        console.log(item)
        item.last_visit = this._setDate(item.last_visit)//dayjs(item.last_visit).unix().toString()
        item.reminder_date = this._setDate(item.reminder_date)//dayjs(item.reminder_date).unix().toString()

        const data = this.network.postItem<{ success: boolean, item_id: string }>('jet-cct/visits', item)
        return data.loading()
    }
    public update = (item: IHorseVisit) => {

        item.last_visit = this._setDate(item.last_visit)
        item.reminder_date = this._setDate(item.reminder_date)

        const data = this.network.postItem<{ success: boolean }>(`jet-cct/visits/${item._ID}`, item)
        return data.loading()
    }

    public delete = (itemId: string) => {
        const data = this.network.delItem('jet-cct/visits/' + itemId)
        return data.loading()
    }

    public getVisits = (profileId: string) => {
        const data = this.network.getItem<IHorseVisit[]>('jet-cct/visits', { horse_id: profileId }).next(res => {
            res.map(item => {
                item.last_visit = this._getDate(item.last_visit)//dayjs(Number(item.last_visit) * 1000).toString()
                item.reminder_date = this._getDate(item.reminder_date)//dayjs(Number(item.reminder_date) * 1000).toString()
                return item
            })
        })

        return data.loading()
    }

    public addProfile = (item: Profile) => {
        item.yob = dayjs(item.yob).unix().toString()
        item.date_purchased = dayjs(item.date_purchased).unix().toString()
        item.nzcar = String(item.nzcar)
        Object.values(item).forEach(value => {
            if (value == null) {
                value = ''
            }
        });
        const data = this.network.postItem<{ item_id: number, success: boolean }>('jet-cct/profile', item)
        return data.loading()
    }

    public updateProfile = (item: Profile) => {
        item.yob = dayjs(item.yob).unix().toString()
        item.date_purchased = dayjs(item.date_purchased).unix().toString()
        item.nzcar = String(item.nzcar)
        Object.values(item).forEach(value => {
            if (value == null) {
                value = ''
            }
        });
        const data = this.network.postItem<string>(`jet-cct/profile/${item._ID}`, item)
        return data.loading()
    }

    public updatePartialProfile = (item: Object, id: string) => {
        const data = this.network.postItem<string>(`jet-cct/profile/${id}`, item)
        return data.loading()
    }

    public deleteProfile = (id: string) => {
        const data = this.network.delItem<string>(`jet-cct/profile/` + id)
        return data.loading()
    }

    public updateAvatar = (url: string, id?: string) => {
        if (id) {
            return this.network.postItem<string>(`jet-cct/profile/${id}`, { avatar: url })
        } else {
            return this.network.postItem<string>(`jet-cct/profile/`, { avatar: url })
        }
    }

    public getProfiles = (usrId: string) => {
        const data = this.network.getItem<Profile[]>('jet-cct/profile', { user_id: usrId }).next(data => {
            return data.map(item => {
                item.yob = dayjs(Number(item.yob) * 1000).toString()
                item.date_purchased = dayjs(Number(item.date_purchased) * 1000).toString()
            })

        })

        return data.loading()
    }

    public getProfile = (id: string) => {
        const data = this.network.getItem<Profile[]>('jet-cct/profile', { _ID: id }).next(data => {
            return data.map(item => {
                item.yob = dayjs(Number(item.yob) * 1000).toString()
                item.date_purchased = dayjs(Number(item.date_purchased) * 1000).toString()
                const str = String(item.nzcar)
                return item;
            })

        })
        return data
    }


    public addContact = (item: Contact) => {

        const data = this.network.postItem<{ success: boolean }>('jet-cct/contacts', item)
        return data.loading()
    }

    public updateContact = (item: Contact) => {

        const data = this.network.postItem<string>(`jet-cct/contacts/${item._ID}`, item)
        return data.complete({ success: 'update success', fail: 'update fail' })
    }

    public getContacts = (profileId: string) => {
        const data = this.network.getItem<Contact[]>('jet-cct/contacts', { profile_id: profileId })

        return data
    }

    public addFile = (item: Files) => {
        const data = this.network.postItem<{ success: boolean }>('jet-cct/horse_files', { ...item })
        return data
    }

    public getFile = (id: string) => {
        const data = this.network.getItem<Files[]>('jet-cct/horse_files', { profile_id: id })
        return data
    }
    public getFileByVisitId = (id: string) => {
        const data = this.network.getItem<Files[]>('jet-cct/horse_files', { visit_id: id })
        return data
    }

    public getFileByCalendarId = (id: string) => {
        const data = this.network.getItem<Files[]>('jet-cct/horse_files', { calendar_id: id })
        return data
    }
    public deleteFile = (itemId: string) => {
        const data = this.network.delItem('jet-cct/horse_files/' + itemId)
        return data
    }

    public sendMail = (mail: { email: string, event: string, message: string, address: string, profile_id: string, usr_id: string, date: string | number, description: string }) => {
        const data = this.network.postItem('reset/v1/request_mail', mail)
        return data.loading(undefined, { success: 'Success!', fail: 'Send fail' })
    }

    public sendEmailNotice = (mail: { email: string, title: string, message: string }) => {
        const data = this.network.postItem('reset/v1/send_email_notice', mail)
        return data.loading(undefined, { success: 'Success!', fail: 'Send fail' })
    }

    public createShareKey = (params: ShareKey) => {
        const str = JSON.stringify(params.config)
        const data = this.network.postItem<{
            item_id: number
        }>('jet-cct/profile_sharing', { ...params, config: str })
        return data
    }

    public getAllShareKey = () => {
        const data = this.network.getItem<Array<ShareKey>>('jet-cct/profile_sharing')
        return data
    }

    public getShareKey = (id: string) => {
        const data = this.network.getItem<Array<ShareKey>>('jet-cct/profile_sharing', { profile_id: id }).then(res => {
            return res.map(item => {
                item.config = JSON.parse(item.config as unknown as string)
                return item
            })
        })
        return data
    }

    public updateShareKey = (id: string, config: Array<number | string>) => {
        const data = this.network.postItem(`jet-cct/profile_sharing/${id}`, { config: JSON.stringify(config) })
        return data
    }



    public getProfileIdBySharekey = (key: string) => {
        const data = this.network.getItem<Array<ShareKey>>('jet-cct/profile_sharing', { sharing_key: key })
        return data
    }


    public getUserProfileCapacity = (usrId: string) => {
        const data = this.network.postItem<string>('reset/v1/get_user_meta', { uid: usrId, key: 'purchased_profiles' })

        return data
    }

    public updateUserUsedProfile = (value: number) => {
        const data = this.network.postItem<string>('reset/v1/update_user_used_profile', { value: value })

        return data
    }

    public getProfileOrders = (uid: string) => {
        const data = this.network.getItem<Array<Orders>>('jet-cct/profile_orders', { user_id: uid })
        return data

    }

    public getPreview = (key: string) => {
        return this.network.postItem<Preview>('reset/v1/preview', { preview_id: key }).next(res => {
            Object.keys(res.records).forEach(key => {
                res.records[Number(key)].visits = res.records[Number(key)].visits.map(visit => {
                    visit.last_visit = this._getDate(visit.last_visit)
                    visit.reminder_date = this._getDate(visit.reminder_date)
                    return visit
                })
            })

            res.profile.yob = dayjs(Number(res.profile.yob) * 1000).toString()
            res.profile.date_purchased = dayjs(Number(res.profile.date_purchased) * 1000).toString()
            return res
        })
    }

    public getCalendar = (usrId: string, profileId?: string) => {
        const data = this.network.postItem<Calendar[]>('reset/v1/calendar', { usr_id: usrId, profile_id: profileId })
        return data
    }

    public getAllEvents = (currentPage?: number, sortField?: string | null, sortOrder?: string) => {
        const data = this.network.postItem<PageList<Calendar[]>>('reset/v1/get_all_events', { page: currentPage, sortField: sortField, sortOrder: sortOrder })
        return data
    }

    public getPublishedEvents = () => {
        const data = this.network.postItem<PageList<Calendar[]>>('reset/v1/get_published_events')
        return data
    }

    public changeEventStauts = (userId: string, calendarId: number, status: string) => {
        const data = this.network.postItem<{
            'status': string,
            '_id': number,
        }>('reset/v1/audit_events', { usr_id: userId, calendar_id: calendarId, status: status })
        return data
    }


    public addCalendar = (usrId: string, update: CalendarUpdate) => {
        const data = this.network.postItem<{ _ID: number }>('reset/v1/add_calendar_events', { usr_id: usrId, ...update })
        return data
    }
    public deleteCalendar = (id: string) => {
        const data = this.network.delItem('jet-cct/calendar/' + id).loading()
        return data
    }
    public getMembershipValid = () => {
        return this.network.getItem<boolean>('reset/v1/get_membership_valid').loading()
    }
}
const Horse = (network: NetworkApi) => new HorseNetwork(network);
export default Horse
